import { initSegmentedCodeInput } from './segmented_code_input';

export const initPasswordRecoveryOtpCodeInput = () => initSegmentedCodeInput({
  boxSelector: '.devise-form-password-recovery-otp__code-input',
  continueButtonId: 'password-recovery-otp-continue',
  codeFieldId: 'password-recovery-otp-code-value',
});
